import { postRequest } from '@/core';
import { legs } from '@/requests';

export default async function broadcastLegRequest({ legId, tripId }) {
	let url = legs.getBroadcastPath(legId);
	let response = await postRequest(url, {}, { tripId });
	return response;
}
